<template>
  <v-card
    v-if="visible"
    ref="booking_timewindow"
    id="booking-timewindow"
    elevation="0"
    class="mx-auto secondary rounded-0"
  >
    <CardHeader title="5. HVORNÅR?" />
    <div>
      <v-row
        no-gutters
        :class="
          this.$vuetify.breakpoint.smAndDown ? 'pt-2 px-0' : 'pt-6 pb-2 px-7'
        "
      >
        <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 2" class="px-2">
          <v-menu
            ref="datePicker"
            v-model="datePickerVisible"
            :close-on-content-click="true"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                ref="pickupFromDate"
                :value="pickupFromDate | formatDate"
                id="pickupFromDate"
                label="Afhentningsdato"
                persistent-hint
                v-bind="attrs"
                v-on="on"
                required
                readonly
                :rules="pickupFromDateRules()"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pickupFromDate"
              no-title
              @input="
                datePickerVisible = false;
                focusPickupFromDate();
              "
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 2" class="px-2">
          <v-text-field
            type="time"
            ref="pickupFromTime"
            v-model="pickupFromTime"
            id="pickupFromTime"
            label="Afhentning tidligst"
            required
            :rules="pickupFromTimeRules()"
            outlined
            dense
            color="primary"
            background-color="white"
          ></v-text-field>
          <!-- <v-dialog
            ref="pickupFromTimeDialog"
            v-model="displayPickupFromTimePicker"
            :return-value.sync="pickupFromTime"
            persistent
            width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                ref="pickupFromTime"
                v-model="pickupFromTime"
                id="pickupFromTime"
                label="Afhentning tidligst"
                required
                :rules="pickupFromTimeRules()"
                outlined
                dense
                color="primary"
                background-color="white"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-time-picker
              v-if="displayPickupFromTimePicker"
              v-model="pickupFromTime"
              full-width
              format="24hr"
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="displayPickupFromTimePicker = false"
              >
                Fortryd
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="$refs.pickupFromTimeDialog.save(pickupFromTime)"
              >
                OK
              </v-btn>
            </v-time-picker>
          </v-dialog> -->
        </v-col>
        <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 4 : 2" class="px-2">
          <v-select
            ref="pickupToTime"
            v-model="pickupTo"
            :items="pickupToTimewindows"
            item-value="time"
            item-text="to_string"
            label="Afhentning senest"
            no-data-text="Ingen tidsvinduer tilgængelige"
            return-object
            required
            :rules="pickupToTimeRules()"
            :disabled="!pickupFromTime"
            outlined
            dense
            color="primary"
            background-color="white"
            :menu-props="{ contentClass: 'combobox-styled', nudgeBottom: 30 }"
          ></v-select>
        </v-col>
        <v-col :cols="this.$vuetify.breakpoint.smAndDown ? 12 : 6" class="px-2">
          <v-text-field
            :value="deliveryTimewindow | parseDeliveryTimewindow"
            id="deliveryTimewindow"
            label="Forventet levering"
            disabled
            outlined
            dense
            color="primary"
            background-color="white"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
  </v-card>
</template>

<script>
import { tools } from "../helpers";
import CardHeader from "@/components/templates/CardHeader.vue";
// import { dictionary } from "../helpers";

export default {
  name: "Timewindow",
  components: { CardHeader },
  created() {
    this.updatePickupToTimewindows();
  },
  filters: {
    formatDate: function(date) {
      return tools.formatDate(date);
    },
    parseDeliveryTimewindow: function(timewindow) {
      if (
        !timewindow ||
        !timewindow.from ||
        !timewindow.to ||
        !timewindow.from.date ||
        !timewindow.to.date ||
        !timewindow.from.time ||
        !timewindow.to.time
      ) {
        return null;
      }
      const [fromYear, fromMonth, fromDay] = timewindow.from.date.split("-");
      const [toYear, toMonth, toDay] = timewindow.to.date.split("-");
      const fromTime = timewindow.from.time;
      const toTime = timewindow.to.time;

      return `${fromDay}-${fromMonth}-${fromYear} ${fromTime} - ${toDay}-${toMonth}-${toYear} ${toTime}`;
    }
  },
  data: () => ({
    // openDisplayIcon: dictionary.mdi.open,
    // closeDisplayIcon: dictionary.mdi.close,
    datePickerVisible: false,
    displayPickupFromTimePicker: false,
    pickupToTimewindows: []
  }),
  computed: {
    displayTimewindow: {
      get() {
        return this.$store.state.booking.display_timewindow;
      },
      set(value) {
        this.$store.state.booking.display_timewindow = value;
      }
    },
    earliestPosiblePickup() {
      return this.$store.state.booking.earliest_posible_pickup;
    },
    visible: {
      get() {
        return (
          this.$store.state.booking.data.account &&
          this.$store.state.booking.data.pickup.address.address &&
          this.$store.state.booking.data.pickup.address.name &&
          this.$store.state.booking.data.delivery.address.address &&
          this.$store.state.booking.data.delivery.address.name &&
          this.goodsValid() &&
          this.$store.state.booking.data.vehicle_type &&
          this.$store.state.booking.data.vehicle_type.external_key
        );
      }
    },
    pickupFromDate: {
      get() {
        return this.$store.state.booking.data.pickup.timewindow.from.date;
      },
      set(value) {
        this.$store.commit("booking/updatePickupTimewindowFromDate", value);
        this.updatePickupToTimewindows();
        this.updateETA();
      }
    },
    pickupFromTime: {
      get() {
        return this.$store.state.booking.data.pickup.timewindow.from.time;
      },
      set(value) {
        this.$store.commit("booking/updatePickupTimewindowFromTime", value);
      }
    },
    pickupTo: {
      get() {
        return this.$store.state.booking.data.pickup.timewindow.to;
      },
      set(value) {
        this.$store.commit("booking/updatePickupTimewindowTo", value);
        this.calculatePrice();
      }
    },
    deliveryTimewindow: {
      get() {
        return this.$store.state.booking.data.delivery.timewindow;
      }
    },
    accountId: {
      get() {
        return this.$store.state.booking.data.account.id;
      }
    },
    pickupLat: {
      get() {
        return this.$store.state.booking.data.pickup.address.lat;
      }
    },
    deliveryLat: {
      get() {
        return this.$store.state.booking.data.delivery.address.lat;
      }
    },
    deliveryRoute: {
      get() {
        return this.$store.state.booking.data.delivery.route;
      }
    },
    vehicleType: {
      get() {
        return this.$store.state.booking.data.vehicle_type.external_key;
      }
    }
  },
  watch: {
    visible: {
      handler(newVal, oldVal) {
        if (newVal && newVal != oldVal) {
          this.$nextTick(() => {
            this.$vuetify.goTo(this.$refs.booking_timewindow);
          });
        }
      }
    },
    pickupFromTime() {
      this.updatePickupToTimewindows();
      this.updateETA();
    },
    pickupTo() {
      this.updateETA();
    },
    accountId() {
      const useOwnAddressAs = this.$store.getters["user/useOwnAddressAs"];
      if (!useOwnAddressAs) {
        this.updatePickupToTimewindows();
      }
    },
    pickupLat() {
      this.calculateRoute();
      this.updatePickupToTimewindows();
      this.updateETA();
    },
    deliveryLat() {
      this.calculateRoute();
      this.updatePickupToTimewindows();
      this.updateETA();
    },
    deliveryRoute: {
      deep: true,
      handler() {
        this.updateETA();
      }
    },
    vehicleType(newVal, oldVal) {
      const fromTimeBufferInMinutes = newVal == "15PLT" ? 60 : 0;

      if (oldVal == "") {
        let earliestPosiblePickup = this.$store.state.booking
          .earliest_posible_pickup;

        earliestPosiblePickup = new Date(
          earliestPosiblePickup.getTime() + fromTimeBufferInMinutes * 60 * 1000
        );

        const dateTime = tools.splitDateTime(earliestPosiblePickup);

        this.$store.commit(
          "booking/updatePickupTimewindowFromDate",
          dateTime.date
        );
        this.$store.commit(
          "booking/updatePickupTimewindowFromTime",
          dateTime.time
        );
      }
    }
  },
  methods: {
    pickupFromDateRules() {
      return [
        v => !!v || false,
        v => {
          return this.validatePickup(v);
        }
      ];
    },
    pickupFromTimeRules() {
      return [
        v => !!v || false,
        v => {
          return this.validatePickup(v);
        }
      ];
    },
    pickupToTimeRules() {
      return [
        v => !!v || false,
        v => {
          return !v || v.time != "" || false;
        }
      ];
    },
    validatePickup() {
      let d = new Date(
        this.$store.state.booking.data.pickup.timewindow.from.date
      );
      const hoursMinutes = tools.splitHoursMinutes(
        this.$store.state.booking.data.pickup.timewindow.from.time
      );
      d.setHours(hoursMinutes.hours, hoursMinutes.minutes, 0, 0);

      // if 15plt; add 60 min
      const fromTimeBufferInMinutes =
        this.$store.state.booking.data.vehicle_type.external_key == "15PLT"
          ? 60
          : 0;

      return (
        this.earliestPosiblePickup.getTime() +
          fromTimeBufferInMinutes * 60 * 1000 <=
          d.getTime() ||
        "Afhentning tidligst " +
          tools.formatDate(
            tools.splitDateTime(
              new Date(
                this.earliestPosiblePickup.getTime() +
                  fromTimeBufferInMinutes * 60 * 1000
              )
            ).date
          ) +
          " " +
          tools.splitDateTime(
            new Date(
              this.earliestPosiblePickup.getTime() +
                fromTimeBufferInMinutes * 60 * 1000
            )
          ).time
      );
    },
    async updatePickupToTimewindows() {
      const { accountId, pickupFromDate, pickupFromTime } = this;
      const pickupZip = this.$store.state.booking.data.pickup.address.zip;
      const deliveryZip = this.$store.state.booking.data.delivery.address.zip;
      if (
        accountId &&
        pickupFromDate &&
        pickupFromTime &&
        pickupZip &&
        deliveryZip
      ) {
        await this.$store
          .dispatch("booking/getPickupTimeWindows", {
            accountId,
            pickupZip,
            deliveryZip,
            pickupFromDate,
            pickupFromTime
          })
          .then(
            response => {
              this.pickupToTimewindows = [];
              response.forEach(timestamp => {
                this.pickupToTimewindows.push({
                  date: tools.splitDateTime(new Date(timestamp.to)).date,
                  time: tools.splitDateTime(new Date(timestamp.to)).time,
                  to_string: tools.pickupToTimewindowsToString(timestamp)
                });
              });
              let isToTimeSet = false;
              var BreakException = {};
              try {
                this.pickupToTimewindows.forEach(timestamp => {
                  if (
                    timestamp.date ===
                      this.$store.state.booking.data.pickup.timewindow.to
                        .date &&
                    timestamp.time ===
                      this.$store.state.booking.data.pickup.timewindow.to.time
                  ) {
                    isToTimeSet = true;
                    throw BreakException;
                  }
                });
              } catch (e) {
                if (e !== BreakException) throw e;
              }
              if (!isToTimeSet) {
                //reset to time
                this.$store.commit("booking/updatePickupTimewindowTo", {
                  date: "",
                  time: ""
                });
              } else {
                this.calculatePrice();
              }
            },
            error => {
              console.error(error);
            }
          );
      }
    },
    async updateETA() {
      const { accountId, pickupFromDate, pickupFromTime, pickupTo } = this;
      const pickupToDate = pickupTo ? pickupTo.date : null;
      const pickupToTime = pickupTo ? pickupTo.time : null;
      const pickupZip = this.$store.state.booking.data.pickup.address.zip;
      const deliveryZip = this.$store.state.booking.data.delivery.address.zip;
      const stopDrivetimes = [
        {
          stopOrder: 1,
          drivetime:
            this.$store.state.booking.data.pickup.route &&
            this.$store.state.booking.data.pickup.route.drivetime_seconds
              ? this.$store.state.booking.data.pickup.route.drivetime_seconds
              : 0
        },
        {
          stopOrder: 2,
          drivetime:
            this.$store.state.booking.data.delivery.route &&
            this.$store.state.booking.data.delivery.route.drivetime_seconds
              ? this.$store.state.booking.data.delivery.route.drivetime_seconds
              : 0
        }
      ];
      if (
        accountId &&
        pickupZip &&
        deliveryZip &&
        pickupFromDate &&
        pickupFromTime &&
        pickupToDate &&
        pickupToTime &&
        stopDrivetimes
      ) {
        await this.$store
          .dispatch("booking/calculateETA", {
            accountId,
            pickupZip,
            deliveryZip,
            pickupFromDate,
            pickupFromTime,
            pickupToDate,
            pickupToTime,
            stopDrivetimes
          })
          .then(
            response => {
              if (response) {
                const deliveryFrom = response.find(x => x.stoporder == "2").eta
                  .from;
                const deliveryTo = response.find(x => x.stoporder == "2").eta
                  .to;

                const fromDateTime = tools.splitDateTime(
                  new Date(deliveryFrom)
                );
                const toDateTime = tools.splitDateTime(new Date(deliveryTo));

                this.$store.commit("booking/updateDeliveryTimewindow", {
                  from: { date: fromDateTime.date, time: fromDateTime.time },
                  to: { date: toDateTime.date, time: toDateTime.time }
                });
              }
            },
            error => {
              console.error(error);
            }
          );
      } else {
        this.$store.commit("booking/updateDeliveryTimewindow", {
          from: { date: "", time: "" },
          to: { date: "", time: "" }
        });
      }
    },
    async calculateRoute() {
      await this.$store.dispatch("booking/calculateRoute");
    },
    async calculatePrice() {
      await this.$store.dispatch("booking/calculatePrice");
    },
    goodsValid() {
      return (
        this.$store.state.booking.data.goods &&
        this.$store.state.booking.data.goods[0] &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].cll) > 0 &&
        this.$store.state.booking.data.goods[0].description.length > 0 &&
        tools.parseDouble(this.$store.state.booking.data.goods[0].weight) > 0
      );
    },
    focusPickupFromDate() {
      this.$refs.pickupFromDate.focus();
    }
  }
};
</script>
